import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Injects GA4, Meta Pixel, and optional GTM based on env vars.
 * Zero-impact when IDs are not set.
 */
export const Analytics = () => {
  const { pathname } = useLocation();
  const GA_ID = process.env.REACT_APP_GA4_ID;
  const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
  const GTM_ID = process.env.REACT_APP_GTM_ID;

  // Install once
  useEffect(() => {
    if (GA_ID && !window.__gaLoaded) {
      window.__gaLoaded = true;
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", GA_ID, { send_page_view: false });
    }
    if (PIXEL_ID && !window.__fbLoaded) {
      window.__fbLoaded = true;
      /* eslint-disable */
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
      window.fbq("init", PIXEL_ID);
    }
    if (GTM_ID && !window.__gtmLoaded) {
      window.__gtmLoaded = true;
      /* eslint-disable */
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',GTM_ID);
      /* eslint-enable */
    }
  }, [GA_ID, PIXEL_ID, GTM_ID]);

  // Fire page_view on route change
  useEffect(() => {
    if (window.gtag && GA_ID) window.gtag("event", "page_view", { page_path: pathname });
    if (window.fbq && PIXEL_ID) window.fbq("track", "PageView");
  }, [pathname, GA_ID, PIXEL_ID]);

  return null;
};

export default Analytics;
